<mat-card class="card-actions" [class.modern-filter-card]="useModernActions">
  <div class="flex-container">
    <div class="flex-box" *ngIf="hasExportExcelButton && !useModernActions">
      <div class="text-center mx-2">
        <button mat-icon-button class="icon-action-print" matTooltip="Exportar a Excel" aria-label="Exportar a Excel"
          (click)="printFile(true)" [disabled]="!useModernActions && exportExcelButtonDisabled">
          <i class="fas fa-file-download"></i>
        </button>
      </div>
    </div>

    <div *ngIf="!showRangePicker;else rangePicker">
      <div class="flex-box">
        <mat-form-field appearance="outline" class="mat-form-field-date" [class.modern-date-field]="useModernActions">
          <mat-label>Periodo</mat-label>
          <input matInput [matDatepicker]="dp" [formControl]="date" [max]="maxDate" [min]="minDate">
          <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
          <mat-datepicker #dp startView="multi-year" (yearSelected)="chosenYearHandler($event)"
            (monthSelected)="chosenMonthHandler($event, dp)" panelClass="example-month-picker">
          </mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <ng-template #rangePicker>
      <div class="flex-box">
        <mat-form-field appearance="outline" class="mat-form-field-date" [class.modern-date-field]="useModernActions">
          <mat-label>Desde</mat-label>
          <input matInput [matDatepicker]="dpStart" [formControl]="start" [min]="minDate" (dateChange)="desdeChanged()">
          <mat-datepicker-toggle matSuffix [for]="dpStart"></mat-datepicker-toggle>
          <mat-datepicker #dpStart [disabled]="false">
          </mat-datepicker>
        </mat-form-field>
      </div>

      <div class="flex-box">
        <mat-form-field appearance="outline" class="mat-form-field-date" [class.modern-date-field]="useModernActions">
          <mat-label>Hasta</mat-label>
          <input matInput [matDatepicker]="dpEnd" [formControl]="end" [min]="start.value" [max]="maxRangeDate">
          <mat-datepicker-toggle matSuffix [for]="dpEnd"></mat-datepicker-toggle>
          <mat-datepicker #dpEnd [disabled]="!start.value"></mat-datepicker>
        </mat-form-field>
      </div>
    </ng-template>


    <div class="flex-box">
      <div class="form-field-group">
        <mat-form-field class="seccion select-form-field w-100">
          <mat-label>Sección</mat-label>
          <mat-select [(ngModel)]="idSeccion">
            <mat-option *ngFor="let item of cmbSectorList" [matTooltip]="item.Nsector" [value]="item.IdSector">
              {{ item.Nsector }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="flex-box" *ngIf="hasLegajoInput">
      <mat-form-field class="input-legajo">
        <mat-label>Legajo</mat-label>
        <input matInput placeholder="" [(ngModel)]="legajo">
      </mat-form-field>
    </div>

    <div class="flex-box">
      <div class="filter-card-actions">
        <button *ngIf="hasExportExcelButton && useModernActions" mat-stroked-button
          class="export-button" matTooltip="Exportar a Excel" aria-label="Exportar a Excel"
          (click)="printFile(true)" [disabled]="exportExcelButtonDisabled">
          <mat-icon>download</mat-icon>
          <span>Exportar</span>
        </button>
        <button mat-raised-button color="primary" class="filter-button" (click)="filter()">
          <mat-icon *ngIf="useModernActions">search</mat-icon>
          <span>{{ filterButtonText }}</span>
        </button>
      </div>
    </div>
  </div>
</mat-card>
